import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const optStr = (max: number) => z.string().trim().max(max).optional().nullable();

const PayloadSchema = z.object({
  event_name: z.string().min(1).max(80),
  session_id: optStr(128),
  path: z.string().max(500).optional().nullable(),
  source: z.string().max(80).optional().nullable(),
  platform: z.string().max(40).optional().nullable(),
  utm_source: optStr(200),
  utm_medium: optStr(200),
  utm_campaign: optStr(200),
  properties: z.record(z.string(), z.any()).optional().default({}),
});

export const logAnalyticsEvent = createServerFn({ method: "POST" })
  .inputValidator((data) => PayloadSchema.parse(data))
  .handler(async ({ data }) => {
    try {
      const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
      await supabaseAdmin.from("analytics_events").insert({
        event_name: data.event_name,
        session_id: data.session_id ?? null,
        path: data.path ?? null,
        source: data.source ?? null,
        platform: data.platform ?? null,
        utm_source: data.utm_source ?? null,
        utm_medium: data.utm_medium ?? null,
        utm_campaign: data.utm_campaign ?? null,
        properties: data.properties ?? {},
      } as never);
      return { ok: true };
    } catch (e) {
      console.error("[analytics] insert failed", e);
      return { ok: false };
    }
  });
